import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeJourneyParam } from '@store/yourJourney/actions';
import { entitySelectors } from '@store/entity/selectors';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { SpaTreatmentsCategory, SpaTreatmentsCategoryProps } from './SpaTreatmentsCategory';

interface StateProps {
  property: SpaTreatmentsCategoryProps['property'];
  journeyParams: SpaTreatmentsCategoryProps['journeyParams'];
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      changeJourneyParam,
    },
    dispatch
  );

const mapStateToProps = (state): StateProps => {
  const journeyParams = yourJourneySelectors.getParsedJourneyParams(state);

  return {
    property: entitySelectors.getProperty(state),
    journeyParams,
  };
};

const _connected: any = connect(mapStateToProps, mapDispatchToProps)(SpaTreatmentsCategory);
export default _connected;
